import { Cat } from 'lucide-react'
import type { Pet } from '../types'

export function PetAvatar({ pet, size = 'medium' }: { pet: Pet; size?: 'small' | 'medium' | 'large' }) {
  return <span className={`pet-avatar ${pet.accent} ${size}`} aria-hidden="true"><Cat /></span>
}
